<app-icon [icon]="icon"></app-icon>
{{ creditCard.name }}
{{ creditCard.number }}
